<template>
  <router-view />
  <ToastHost />
</template>

<script setup>
// Auth is initialized in main.js before App mounts
import ToastHost from '@/components/common/ToastHost.vue'
</script>
